/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Hilldun_Term_CodeInputs */

const en_reference_field_hilldun_term_code = /** @type {(inputs: Reference_Field_Hilldun_Term_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilldun term code`)
};

/**
* | output |
* | --- |
* | "Hilldun term code" |
*
* @param {Reference_Field_Hilldun_Term_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_hilldun_term_code = /** @type {((inputs?: Reference_Field_Hilldun_Term_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Hilldun_Term_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_hilldun_term_code(inputs)
});